// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__19aF9","DarkMode":"Modal_DarkMode__Nzf10","CloseBtn":"Modal_CloseBtn__hThfj","WhiteCloseButton":"Modal_WhiteCloseButton__3m96C"};